import { IS_PRODUCTION } from '@updater-core/lib/environment';
import { ENGAGE, track } from '@updater-core/lib/tracker';

export const trackEngagement = (details) => {
  if (!IS_PRODUCTION) {
    if (!details.hasOwnProperty('code')) {
      console.warn(
        '--- Step engagement events MUST have a code property. You provided:',
        details
      );
    }

    if (!details.hasOwnProperty('name')) {
      console.warn(
        '--- Step engagement events MUST have a name property. You provided:',
        details
      );
    }
  }

  track({
    verb: ENGAGE,
    object: 'step',
    details,
  });
};
